import { render, staticRenderFns } from "./ContractDocumentHistory.vue?vue&type=template&id=2ac58a55&scoped=true"
import script from "./ContractDocumentHistory.vue?vue&type=script&lang=js"
export * from "./ContractDocumentHistory.vue?vue&type=script&lang=js"
import style0 from "./ContractDocumentHistory.vue?vue&type=style&index=0&id=2ac58a55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac58a55",
  null
  
)

export default component.exports